/**
 * Recently Viewed Listings — localStorage helpers.
 * Stores the last N listings a user clicked into, with enough metadata
 * to render a compact card without another API round-trip.
 */

const STORAGE_KEY = 'ato_recently_viewed_v1';
const MAX_ITEMS = 5;

/**
 * @typedef {Object} RecentListing
 * @property {string} listing_id
 * @property {string} title
 * @property {number} price_mga
 * @property {string} [city]
 * @property {string} [category]
 * @property {string} [image]       // first image file_id
 * @property {number} viewed_at     // ms epoch
 */

/** Returns the list, most-recent first. Safe against SSR / private-mode. */
export const getRecentlyViewed = () => {
  if (typeof window === 'undefined') return [];
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

/** Add or move a listing to the top of the list. Keeps at most MAX_ITEMS. */
export const addRecentlyViewed = (listing) => {
  if (typeof window === 'undefined' || !listing || !listing.listing_id) return;
  try {
    const entry = {
      listing_id: listing.listing_id,
      title: listing.title,
      price_mga: listing.price_mga,
      city: listing.city,
      category: listing.category,
      image: Array.isArray(listing.images) && listing.images.length > 0 ? listing.images[0] : null,
      viewed_at: Date.now(),
    };
    const current = getRecentlyViewed().filter(l => l.listing_id !== entry.listing_id);
    const next = [entry, ...current].slice(0, MAX_ITEMS);
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch (err) {
    /* quota / private mode — silently ignore */
    if (typeof console !== 'undefined') console.debug('recentlyViewed.add failed:', err);
  }
};

export const clearRecentlyViewed = () => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch (err) {
    if (typeof console !== 'undefined') console.debug('recentlyViewed.clear failed:', err);
  }
};
